import EnemyType from "../../enums/EnemyType";

const DIFFICULT_ENEMYS = {
  [EnemyType.REPTILE]: [
    {
      level: 10,
      maxHp: 40,
      speed: 80,
      power: 35,
      knockback: 0,
      deathKB: 0,
      killedAmount: 0,
      scale: 1.5,
      xp: 3,
      spriteName: "reptile",
      animationKey: "reptile_run",
    },
  ],
};
export default DIFFICULT_ENEMYS;
